import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_sst_payment_collection,
    getReportLabel: () => t`SST Payment Collection`,
    getColumns: () => [],
};
